<template>
  <div class="list-of-comments">
    <div v-for="comment in comments"
      :key="comment.id"
      :id="comment.id"
      :ref="comment.id"
      draggable
      @dragstart='startDrag($event, comment)'
      class="comment-li md-elevation-8 hidden"
    >
      <span class="comment md-title">{{ comment.comment }}</span>
      <span class="authored_by md-caption">{{ comment.authored_by }}
        @ <a class="md-caption" :href="'#' + comment.timestamp">
          {{ new Date(comment.timestamp * 1000).toISOString().substr(14, 5) }}
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Comments',
  methods: {
    startDrag: (ev, comment) => {
      ev.dataTransfer.dropEffect = 'move';
      ev.dataTransfer.effectAllowed = 'move';
      ev.dataTransfer.setData('commentID', comment.id);

      // elements of grid
      const dropzone = document.querySelectorAll('.dropzone');

      for (let i = 0; i < dropzone.length; i += 1) {
        // set & reset hover effect
        dropzone[i].style.background = 'rgba(123, 123, 123, .2)';
        setTimeout(() => { dropzone[i].style.background = 'none'; }, 2500);
      }
    },
    onDrop(ev) {
      const commentID = ev.dataTransfer.getData('commentID');
      const commentFromProps = this.$props.comments.find(comment => comment.id === commentID);
      const draggable = document.getElementById(commentFromProps.id);
      if (ev.target.className !== 'comment md-title') {
        ev.target.appendChild(draggable);
      }
    },
    assignComments: ({
      dropzone,
      comments,
      width,
    }) => {
      if (width >= 960) {
        for (let i = 0; i < comments.length; i += 1) {
          // if big screen make draggable
          comments[i].draggable = 'true';
          const randomZone = dropzone[Math.floor(Math.random() * dropzone.length)];
          randomZone.appendChild(comments[i]);
        }
      } else {
        // fill grid spaces. Not draggable
        for (let i = 0; i < comments.length; i += 1) {
          comments[i].draggable = '';
          dropzone[0].appendChild(comments[i]);
        }
      }
    },
  },
  watch: {
    largescreen() {
      // re-sort comments based on media queries
      this.assignComments({
        dropzone: document.querySelectorAll('.dropzone'),
        comments: document.querySelectorAll('.comment-li'),
        width: window.innerWidth,
      });
    },
  },
  mounted() {
    this.assignComments({
      dropzone: document.querySelectorAll('.dropzone'),
      comments: document.querySelectorAll('.comment-li'),
      width: window.innerWidth,
    });
  },
  props: {
    comments: {
      type: Array,
    },
    largescreen: {
      type: Boolean,
    },
  },
};
</script>

<style>
.hidden {
  display: none !important;
}

.comment-li {
  background: rgba(6, 214, 160, .9);
  width: max-content;
  max-width: 300px;
  margin: 2px;
  padding: 12px 24px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  cursor: pointer;
}

.comment-li > span:last-child {
  align-self: flex-end;
}

@media screen and (max-width: 960px) {
  .comment-li {
    width: auto;
    max-width: inherit;
  }
}

.fade-in {
  -webkit-animation: fade-in 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  animation: fade-in 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2021-3-1 19:18:44
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation fade-in
 * ----------------------------------------
 */
@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MediaPlayer/Comments.vue